import './react-phone-number-input.css'
import { useState, useEffect } from 'react';

import buscarCep from 'src/actions/chats/buscarCep';
import Iconify from 'src/components/Iconify';
import { Tooltip } from '@mui/material';
import ModalAlerta from 'src/components/modal/ModalAlerta';
import PhoneInput from 'react-phone-number-input'
import { RowInput } from 'src/components/forms/RowInput';
import { maskCPF, maskDate } from 'src/utils/functions';
import v2_actionEditarContato from 'src/actions/v2/contatos/v2_actionEditarContato';
import { useSnackbar } from 'notistack';
import v2_actionListarListas from 'src/actions/v2/contatos/v2_actionListarListas';
import { Input } from 'src/@/components/ui/input';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'src/@/components/ui/accordion';
import { Button } from 'src/@/components/ui/button';
import { MultiSelect } from 'src/@/components/ui/multi-select';
import { Separator } from 'src/@/components/ui/separator';

// ----------------------------------------------------------------------

export default function VerContatoForm({
    user,
    cliente,
    open,
    contatoData,
    showSaveButton,
    onClose,
    callbackAddContact,
    callBackRefreshList
}) {
    const [contato, setContato] = useState({
        nome: contatoData?.nome,
        email: contatoData?.info?.email,
        whatsapp: contatoData?.telefone,
        dataNascimento: contatoData?.info?.dataNascimento,
        cpf: contatoData?.info?.cpf
    });
    const [endereco, setEndereco] = useState({
        cep: contatoData?.info?.endereco?.cep,
        rua: contatoData?.info?.endereco?.rua,
        numero: contatoData?.info?.endereco?.numero,
        bairro: contatoData?.info?.endereco?.bairro,
        cidade: contatoData?.info?.endereco?.cidade,
        estado: contatoData?.info?.endereco?.estado,
        complemento: contatoData?.info?.endereco?.complemento
    });

    const [allListas, setAllListas] = useState([]);
    const [selectedListas, setSelectedListas] = useState([]);

    const { enqueueSnackbar } = useSnackbar();
    const [openModalAlerta, setOpenModalAlerta] = useState(false);
    const [mensagemModalAlerta, setMensagemModalAlerta] = useState('');
    const [loading, setLoading] = useState(false);

    const handleCallbackAddContact = () => {
        let data = {
            contato,
            endereco,
            camposPersonalizados,
            contact_lists_id: selectedListas.map(l => l._id || l)
        }
        callbackAddContact(data)
        clearFields();
    }

    useEffect(() => {
        setContato({
            nome: contatoData?.nome,
            email: contatoData?.info?.email,
            whatsapp: contatoData?.telefone,
            dataNascimento: contatoData?.info?.dataNascimento,
            cpf: contatoData?.info?.cpf
        });
        setEndereco({
            cep: contatoData?.info?.endereco?.cep,
            rua: contatoData?.info?.endereco?.rua,
            numero: contatoData?.info?.endereco?.numero,
            bairro: contatoData?.info?.endereco?.bairro,
            cidade: contatoData?.info?.endereco?.cidade,
            estado: contatoData?.info?.endereco?.estado,
            complemento: contatoData?.info?.endereco?.complemento
        });

        setCamposPersonalizados(contatoData?.custom_fields || [])
        setSelectedListas(contatoData?.contact_lists_id || [])

    }, [contatoData, open])

    useEffect(() => {
        async function fetchListas() {
            if (cliente?._id) {
                try {
                    const res = await v2_actionListarListas(cliente._id);
                    setAllListas(res.data.data);
                } catch (error) {
                    console.error(error);
                }
            }
        }
        fetchListas();
    }, [cliente]);

    const [camposPersonalizados, setCamposPersonalizados] = useState([]);
    const [campoPersonalizado, setCampoPersonalizado] = useState({
        nome: '',
        valor: ''
    })

    async function addNovoCampoPersonalizado() {
        if (campoPersonalizado.nome === '' || campoPersonalizado.valor === '') {
            enqueueSnackbar('Preencha os campos', { variant: 'error' });
            return;
        }
        let novoCampo = {
            nome: campoPersonalizado.nome,
            valor: campoPersonalizado.valor
        }
        setCamposPersonalizados([...camposPersonalizados, novoCampo]);
        setCampoPersonalizado({
            nome: '',
            valor: ''
        })
    }

    async function removeCampoPersonalizado(index) {
        let newCampos = camposPersonalizados.filter((item, i) => i !== index)
        setCamposPersonalizados(newCampos)
    }


    async function editarContato() {
        setLoading(true);
        try {
            let data =
            {
                scope: {
                    nome: contato.nome,
                    telefone: contato.whatsapp,
                    info: {
                        email: contato.email,
                        cpf: contato.cpf,
                        dataNascimento: contato.dataNascimento,
                        endereco: {
                            cep: endereco.cep,
                            rua: endereco.rua,
                            bairro: endereco.bairro,
                            cidade: endereco.cidade,
                            estado: endereco.estado,
                            numero: endereco.numero,
                            complemento: endereco.complemento
                        }
                    },
                    custom_fields: camposPersonalizados,
                    contact_lists_id: selectedListas.map(l => l._id || l)
                }
            }

            await v2_actionEditarContato(contatoData._id, data)
            enqueueSnackbar('Contato alterado com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
            setLoading(false);
            callBackRefreshList()
            // setIsChange(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }




    function clearFields() {
        setContato({
            nome: '',
            email: '',
            whatsapp: '',
            dataNascimento: '',
            cpf: ''
        })

        setEndereco({
            cep: "",
            rua: "",
            numero: "",
            bairro: "",
            cidade: "",
            estado: "",
            complemento: ""
        })

    }


    const handleSearchCep = async (zipCode) => {
        try {
            const address = await buscarCep(zipCode)
            if (!address.erro) {
                setEndereco({
                    cep: address.cep,
                    rua: address.logradouro,
                    bairro: address.bairro,
                    cidade: address.localidade,
                    estado: address.uf,
                })

            }
        } catch (address) {

        }
    }

    return (
        <div className="flex flex-col h-full w-full">
            <ModalAlerta
                open={openModalAlerta}
                mensagem={mensagemModalAlerta}
                onClose={() => {
                    setOpenModalAlerta(false);
                    setMensagemModalAlerta('');
                }}
            />

            <div className="flex-1 overflow-y-auto overflow-x-hidden pr-1">
                <div className="space-y-4 pb-4">
                    {/* Dados Básicos */}
                    <div className="space-y-3">

                        <RowInput
                            isRequired={true}
                            label="Nome"
                            input={
                                <Input
                                    onChange={e => setContato({ ...contato, nome: e.target.value })}
                                    value={contato.nome}
                                    placeholder="Nome completo"
                                    className="h-9"
                                />
                            }
                        />

                        <RowInput
                            isRequired={true}
                            label="Telefone"
                            input={
                                <PhoneInput
                                    international
                                    defaultCountry='BR'
                                    className='flex h-9 w-full rounded-md border border-input bg-muted/50 px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50'
                                    disabled={true}
                                    placeholder="Número do WhatsApp"
                                    value={contato.whatsapp}
                                    onChange={value => setContato({ ...contato, whatsapp: value })}
                                />
                            }
                        />

                        <div className="grid grid-cols-2 gap-3">
                            <RowInput
                                label="Data de Nascimento"
                                input={
                                    <Input
                                        onChange={e => setContato({ ...contato, dataNascimento: e.target.value })}
                                        value={contato.dataNascimento && maskDate(contato.dataNascimento)}
                                        placeholder="DD/MM/AAAA"
                                        className="h-9"
                                    />
                                }
                            />
                            <RowInput
                                label="CPF"
                                input={
                                    <Input
                                        onChange={e => setContato({ ...contato, cpf: e.target.value })}
                                        value={contato.cpf && maskCPF(contato.cpf)}
                                        placeholder="000.000.000-00"
                                        className="h-9"
                                    />
                                }
                            />
                        </div>

                        <RowInput
                            label="Email"
                            type="email"
                            input={
                                <Input
                                    onChange={e => setContato({ ...contato, email: e.target.value })}
                                    value={contato.email}
                                    placeholder="email@exemplo.com"
                                    className="h-9"
                                />
                            }
                        />
                    </div>

                    <Separator />

                    {/* Listas */}
                    <div className="space-y-3">
                        <h3 className="text-xs font-semibold text-muted-foreground dark:text-[#ABABAD] uppercase tracking-wide flex items-center gap-1.5">
                            Listas
                            <Tooltip title="Vincule este contato a listas para organizá-lo por segmentos (ex: leads, clientes VIP). Listas facilitam envios em massa e campanhas direcionadas." placement="top">
                                <span className="cursor-help text-muted-foreground/60 hover:text-violet-500 transition-colors">
                                    <Iconify icon="mdi:information-outline" width={14} />
                                </span>
                            </Tooltip>
                        </h3>
                        <MultiSelect
                            options={allListas.map(l => ({ label: l.nome, value: l._id }))}
                            defaultValue={selectedListas.map(l => l._id || l)}
                            onValueChange={(values) => {
                                const newSelected = allListas.filter(l => values.includes(l._id));
                                setSelectedListas(newSelected);
                            }}
                            placeholder="Selecione as listas"
                            className="w-full"
                        />
                    </div>

                    {/* Accordions */}
                    <Accordion type="multiple" className="w-full">
                        <AccordionItem value="endereco" className="border dark:border-[#383838] rounded-lg px-3">
                            <AccordionTrigger className="text-sm font-medium hover:no-underline dark:text-[#D1D2D3]">
                                <div className="flex items-center gap-2">
                                    <Iconify icon="mdi:map-marker-outline" className="w-4 h-4 text-muted-foreground dark:text-[#ABABAD]" />
                                    Endereço
                                </div>
                            </AccordionTrigger>
                            <AccordionContent className="pt-2 pb-4">
                                <div className="space-y-3">
                                    <div className="w-1/2">
                                        <RowInput
                                            label="CEP"
                                            input={
                                                <Input
                                                    onChange={e => setEndereco({ ...endereco, cep: e.target.value })}
                                                    onBlur={e => handleSearchCep(e.target.value)}
                                                    value={endereco.cep}
                                                    placeholder="00000-000"
                                                    className="h-9"
                                                />
                                            }
                                        />
                                    </div>

                                    <RowInput
                                        label="Rua"
                                        input={
                                            <Input
                                                onChange={e => setEndereco({ ...endereco, rua: e.target.value })}
                                                value={endereco.rua}
                                                placeholder="Nome da rua"
                                                className="h-9"
                                            />
                                        }
                                    />

                                    <div className="grid grid-cols-4 gap-3">
                                        <RowInput
                                            label="Número"
                                            input={
                                                <Input
                                                    onChange={e => setEndereco({ ...endereco, numero: e.target.value })}
                                                    value={endereco.numero}
                                                    placeholder="Nº"
                                                    className="h-9"
                                                />
                                            }
                                        />
                                        <div className="col-span-3">
                                            <RowInput
                                                label="Bairro"
                                                input={
                                                    <Input
                                                        onChange={e => setEndereco({ ...endereco, bairro: e.target.value })}
                                                        value={endereco.bairro}
                                                        placeholder="Nome do bairro"
                                                        className="h-9"
                                                    />
                                                }
                                            />
                                        </div>
                                    </div>

                                    <RowInput
                                        label="Complemento"
                                        input={
                                            <Input
                                                onChange={e => setEndereco({ ...endereco, complemento: e.target.value })}
                                                value={endereco.complemento}
                                                placeholder="Apto, bloco, etc."
                                                className="h-9"
                                            />
                                        }
                                    />

                                    <div className="grid grid-cols-4 gap-3">
                                        <div className="col-span-3">
                                            <RowInput
                                                label="Cidade"
                                                input={
                                                    <Input
                                                        onChange={e => setEndereco({ ...endereco, cidade: e.target.value })}
                                                        value={endereco.cidade}
                                                        placeholder="Cidade"
                                                        className="h-9"
                                                    />
                                                }
                                            />
                                        </div>
                                        <RowInput
                                            label="UF"
                                            input={
                                                <Input
                                                    onChange={e => setEndereco({ ...endereco, estado: e.target.value })}
                                                    value={endereco.estado}
                                                    placeholder="UF"
                                                    className="h-9"
                                                />
                                            }
                                        />
                                    </div>
                                </div>
                            </AccordionContent>
                        </AccordionItem>

                        <AccordionItem value="campos-personalizados" className="border dark:border-[#383838] rounded-lg px-3 mt-2">
                            <AccordionTrigger className="text-sm font-medium hover:no-underline dark:text-[#D1D2D3]">
                                <div className="flex items-center gap-2">
                                    <Iconify icon="mdi:form-textbox" className="w-4 h-4 text-muted-foreground dark:text-[#ABABAD]" />
                                    Campos personalizados
                                    {camposPersonalizados.length > 0 && (
                                        <span className="ml-1 text-xs bg-muted text-muted-foreground px-1.5 py-0.5 rounded-full">
                                            {camposPersonalizados.length}
                                        </span>
                                    )}
                                </div>
                            </AccordionTrigger>
                            <AccordionContent className="pt-2 pb-4">
                                <div className="space-y-3">
                                    {camposPersonalizados.map((item, index) => (
                                        <div key={index} className="flex items-end gap-2 p-2 bg-muted/30 dark:bg-[#383838]/30 rounded-md">
                                            <div className="flex-1">
                                                <RowInput
                                                    label={item.nome}
                                                    input={
                                                        <Input
                                                            onChange={e => {
                                                                const newCampos = [...camposPersonalizados];
                                                                newCampos[index].valor = e.target.value;
                                                                setCamposPersonalizados(newCampos);
                                                            }}
                                                            className="h-8 text-sm"
                                                            value={item.valor}
                                                        />
                                                    }
                                                />
                                            </div>
                                            <Button
                                                onClick={() => removeCampoPersonalizado(index)}
                                                variant="ghost"
                                                size="icon"
                                                className="h-8 w-8 text-destructive hover:text-destructive hover:bg-destructive/10"
                                            >
                                                <Iconify icon="mdi:trash-can-outline" className="w-4 h-4" />
                                            </Button>
                                        </div>
                                    ))}

                                    <Separator className="my-3" />

                                    <div className="flex items-end gap-2">
                                        <div className="w-[35%]">
                                            <RowInput
                                                label="Nome do campo"
                                                input={
                                                    <Input
                                                        onChange={e => setCampoPersonalizado({ ...campoPersonalizado, nome: e.target.value })}
                                                        value={campoPersonalizado.nome}
                                                        placeholder="Ex: Empresa"
                                                        className="h-8"
                                                    />
                                                }
                                            />
                                        </div>
                                        <div className="flex-1">
                                            <RowInput
                                                label="Valor"
                                                input={
                                                    <Input
                                                        onChange={e => setCampoPersonalizado({ ...campoPersonalizado, valor: e.target.value })}
                                                        value={campoPersonalizado.valor}
                                                        placeholder="Ex: ACME Corp"
                                                        className="h-8"
                                                    />
                                                }
                                            />
                                        </div>
                                        <Button
                                            onClick={addNovoCampoPersonalizado}
                                            size="icon"
                                            variant="secondary"
                                            className="h-8 w-8"
                                        >
                                            <Iconify icon="mdi:plus" className="w-4 h-4" />
                                        </Button>
                                    </div>
                                </div>
                            </AccordionContent>
                        </AccordionItem>
                    </Accordion>
                </div>
            </div>

            {showSaveButton && (
                <div className="pt-4 border-t dark:border-[#383838] mt-auto">
                    <Button
                        onClick={() => editarContato()}
                        className="w-full h-9"
                        disabled={loading}
                    >
                        {loading ? (
                            <Iconify icon="mdi:loading" className="w-4 h-4 mr-2 animate-spin" />
                        ) : (
                            <Iconify icon="mdi:content-save-outline" className="w-4 h-4 mr-2" />
                        )}
                        Salvar alterações
                    </Button>
                </div>
            )}
        </div>
    );
}
